import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectGroupV2 = _resolveComponent("SelectGroupV2")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_SelectGroupV2, {
      searchCustomerNameMode: "",
      customer: _ctx.selectedCustomer,
      "onUpdate:customer": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedCustomer = $event)),
      customerName: _ctx.customerNameModel,
      "onUpdate:customerName": _cache[2] || (_cache[2] = ($event: any) => (_ctx.customerNameModel = $event)),
      error: _ctx.error,
      errorCaption: _ctx.errorCaption,
      onChange: _ctx.onChange,
      onFocus: _ctx.onFocus,
      onBlur: _ctx.onBlur,
      isEditItem: _ctx.isEditItem,
      onEditItem: _ctx.onEditOption,
      isLoading: _ctx.loading,
      disabled: _ctx.disabled,
      options: _ctx.options,
      disabledUserDropdown: _ctx.disabledOption,
      maxLength: 200,
      format: _ctx.formatName,
      keyValue: "customerPhoneNumber",
      keyName: "customerPhoneNumber",
      placeholder: _ctx.placeholder,
      errorMessage: 
        _ctx.isReverseJourney ? '' : _ctx.$t('bookingV3.errorCustomerNotFound')
      ,
      isShowErrorMessage: _ctx.isReverseJourney ? false : true,
      isShowIconEmpty: _ctx.isReverseJourney ? true : false,
      useInfiniteScroll: _ctx.useInfiniteScroll,
      onScrolled: _ctx.onScroll
    }, {
      option: _withCtx(({ item }) => [
        _createVNode("div", {
          class: "flex-grow truncate pr-1",
          innerHTML: 
            _ctx.highlightSearch(
              `${item?.customerName} (+${item?.customerPhoneNumber})`
            )
          
        }, null, 8, ["innerHTML"])
      ]),
      _: 1
    }, 8, ["customer", "customerName", "error", "errorCaption", "onChange", "onFocus", "onBlur", "isEditItem", "onEditItem", "isLoading", "disabled", "options", "disabledUserDropdown", "format", "placeholder", "errorMessage", "isShowErrorMessage", "isShowIconEmpty", "useInfiniteScroll", "onScrolled"])
  ]))
}